var map = {
	"./banner-img/banner-img.vue": "8ccd",
	"./c-footer/c-footer.vue": "0c82",
	"./c-header/c-header.vue": "ef23",
	"./c-products/c-products.vue": "9a84",
	"./calendar/calendar.vue": "ea77",
	"./contact-us/contact-us.vue": "b8f3",
	"./cookie-box/cookie-box.vue": "a276",
	"./ebc-btn/ebc-btn.vue": "b012",
	"./ebc-dialog/ebc-dialog.vue": "936c",
	"./ebc-rule-list/ebc-rule-list.vue": "5f49",
	"./footer-detail/footer-detail.vue": "310a",
	"./forex-banner/forex-banner.vue": "7cec",
	"./forex-menu/forex-menu.vue": "de4c",
	"./home-header/home-header.vue": "afda",
	"./language/language.vue": "7d35",
	"./message-popup/message-popup.vue": "22da",
	"./message-v3/message-v3.vue": "67cb",
	"./new-footer-white/new-footer-white.vue": "d651",
	"./new-footer/new-footer.vue": "ae3a",
	"./open-account-PAMM/open-account-PAMM.vue": "796f",
	"./open-account-mt45/open-account-mt45.vue": "e215",
	"./open-account/open-account.vue": "4786",
	"./page-footer-mini/page-footer-mini.vue": "20df",
	"./page-footer-win3/page-footer-win3.vue": "13d6",
	"./page-footer/page-footer.vue": "6035",
	"./page-navigate-win3/page-navigate-win3.vue": "ca63",
	"./page-navigate/page-navigate.vue": "eb0f",
	"./page-slogan/page-slogan.vue": "2e77",
	"./page-title/page-title.vue": "5faa",
	"./product-module-new/product-module-new.vue": "da42",
	"./product-module/product-module.vue": "16ed4",
	"./qa-list/qa-list.vue": "f4b7",
	"./ss-banner-new/ss-banner-new.vue": "105e",
	"./ss-banner/ss-banner.vue": "ebbd",
	"./ss-code/ss-code.vue": "a97d",
	"./ss-contact-us-new/ss-contact-us-new.vue": "2ee4",
	"./ss-contact-us/ss-contact-us.vue": "e0af",
	"./ss-footer/ss-footer.vue": "9ec0",
	"./ss-header-white/ss-header-white.vue": "2030",
	"./ss-header/ss-header.vue": "e796",
	"./ss-modal/ss-modal.vue": "d756"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10de";